import { render, staticRenderFns } from "./ProviderNotificationsModal.vue?vue&type=template&id=67c391f9"
import script from "./ProviderNotificationsModal.vue?vue&type=script&lang=js"
export * from "./ProviderNotificationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports